module.exports = __webpack_public_path__ + "src/assets/img/guy_left_4.793f10bc.png";